export default __webpack_public_path__ + "static/media/laundry2-afterB-1024w.6a3d13e8.avif";